(() => {
  const whitespaceErrorFlag = 'atelierWhitespaceError';
  function propertyTextFields(form) {
    return Array.from(form.elements).filter(field =>
      field.name?.startsWith('properties[') && field.required && !field.disabled &&
      ((field.tagName === 'INPUT' && field.type === 'text') || field.tagName === 'TEXTAREA')
    );
  }
  function validatePropertyText(field) {
    if (field.dataset[whitespaceErrorFlag]) {
      field.setCustomValidity('');
      delete field.dataset[whitespaceErrorFlag];
    }
    if (!field.value.trim()) {
      field.setCustomValidity(document.body.dataset.atelierRequiredTextError);
      field.dataset[whitespaceErrorFlag] = 'true';
      return false;
    }
    return true;
  }
  document.addEventListener('input', event => {
    const field = event.target;
    const form = field.form;
    if (!form?.matches('form[id^="AddToCartForm-"]')) return;
    if (propertyTextFields(form).includes(field)) validatePropertyText(field);
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('form[id^="AddToCartForm-"]')) return;
    const invalid = propertyTextFields(form).find(field => !validatePropertyText(field));
    if (!invalid) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    invalid.reportValidity();
  }, true);
  function initialize(root = document) {
    root.querySelectorAll('[data-atelier-review]').forEach(review => {
      if (review.dataset.initialized) return;
      const form = review.closest('form');
      if (!form) return;
      review.dataset.initialized = 'true';
      const fields = review.querySelector('[data-atelier-review-fields]');
      const empty = review.querySelector('[data-atelier-review-empty]');
      let scheduled = false;
      function render() {
        scheduled = false;
        const rows = new Map();
        form.querySelectorAll('input[name], select[name], textarea[name]').forEach(input => {
          const match = /^properties\[(.+)\]$/.exec(input.name);
          if (!match || match[1].startsWith('_') || input.disabled) return;
          if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) return;
          let value = input.type === 'file' ? Array.from(input.files || []).map(file => file.name).join(', ') : input.value;
          if (input.tagName === 'SELECT') value = input.selectedOptions[0]?.textContent || value;
          if (!String(value || '').trim()) return;
          rows.set(match[1], String(value).trim());
        });
        fields.replaceChildren();
        rows.forEach((value, key) => {
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          term.textContent = key;
          description.textContent = value;
          fields.append(term, description);
        });
        empty.hidden = rows.size > 0;
      }
      function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(render); } }
      ['input', 'change', 'click'].forEach(event => form.addEventListener(event, schedule));
      form.addEventListener('reset', schedule);
      render();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
